import React from 'react';
import './OtherRoomsSection.css';

const OtherRoomsSkeleton: React.FC = () => {
    return (
        <section className="other-rooms-section">
            {/* Título de sección */}
            <div className="skeleton h-8 w-64 mx-auto mb-8"></div>

            <div className="other-rooms-grid">
                {/* Generamos 3 tarjetas falsas */}
                {[1, 2, 3].map((i) => (
                    <div key={i} className="room-card">
                        <div className="room-card-image-container skeleton"></div>
                        <div className="skeleton h-6 w-3/4 mx-auto mt-4 mb-2"></div>
                        <div className="skeleton h-10 w-32 mx-auto rounded-full"></div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default OtherRoomsSkeleton;